import { OrderCard } from './OrderCard'
import { useOrdersList } from './useOrders'

export function OrdersBoard() {
  const { data, isLoading, error } = useOrdersList()

  if (isLoading) return <div className="muted">Aufträge werden geladen…</div>
  if (error) {
    return (
      <div className="error" role="alert">
        Aufträge konnten nicht geladen werden.
      </div>
    )
  }
  const orders = data?.orders ?? []

  return (
    <section className="wf-view">
      <div className="wf-viewhead">
        <div>
          <h2 className="viewtitle">Aufträge</h2>
          <p className="sub">Alle Aufträge im Überblick</p>
        </div>
      </div>
      {orders.length === 0 ? (
        <div className="wf-empty">
          <div className="wf-empty__title">Noch keine Aufträge</div>
          <div className="wf-empty__text">Sobald Aufträge angelegt sind, erscheinen sie hier als Karten.</div>
        </div>
      ) : (
        <div className="wf-cardgrid">
          {orders.map((order) => (
            <OrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </section>
  )
}
